
import { ref, computed, onUnmounted } from "vue";
import { isValidPhoneNumber } from "@/utils";
import { useRouter, useRoute } from 'vue-router';

export const useSendCode = (config) => {
  // 是否已经触发过
  const isTriggered = ref(false);
  // 合计时数
  const countDown = ref(0);
  // 定时器
  let timer = null;
  // 是否禁用
  const disabled = computed(() => countDown.value > 0);
  // 发送按钮的文案
  const sendBtnText = computed(() => {
    if (disabled.value) return `${countDown.value}s`;
    if (isTriggered.value) return "再次发送";
    return "获取验证码";
  });
  const send = async (mobile) => {
    if (disabled.value) return;
    if (!mobile) return config.fail && config.fail("手机号不能为空");
    if (!isValidPhoneNumber(mobile)) return config.fail && config.fail("手机号格式错误");
    await config.request(mobile);
    isTriggered.value = true;
    countDown.value = config.countDownCount || 60;
    if (timer) clearInterval(timer);
    timer = setInterval(() => {
      countDown.value--;
      if (countDown.value === 0) clearInterval(timer);
    }, 1000);
  };
  onUnmounted(() => {
    clearInterval(timer);
  });
  return { countDown, send, disabled, sendBtnText };
};

export const usebaseRouter = () => {
  const router = useRouter();
  const route = useRoute();

  const navigate = (option, delay = 0) => {
    setTimeout(() => {
      router.push(option);
    }, delay)
  }

  const back = (delay = 1200) => {
    setTimeout(() => {
      router.back()
    }, delay)
  }

  const getQuery = () => {
    return route.query
  }

  return { navigate, back, getQuery, router, route }
}

export const useLoading = (option = { initialValue: false }) => {
  const isLoading = ref(option.initialValue);

  const startLoading = () => {
    isLoading.value = true;
  }
  const stopLoading = () => {
    isLoading.value = false;
  }
  const withLoading = (promise) => {
    startLoading();
    return promise?.finally(() => {
      stopLoading();
    });
  }

  return { isLoading, startLoading, stopLoading, withLoading }
}